export const DEFAULT_ROLE = "standard user";

export const ROLE_KEYS = {
  ADMINISTRATOR: "administrator",
  POWER_USER: "power user",
  STANDARD_USER: "standard user",
  STANDARD_USER_NO_INVOICING: "standard user (No Invoicing)",
  STANDARD_USER_NO_PRICING: "standard user (No Pricing)",
  WORKFLOW_ONLY: "workflow only",
  DELIVERIES_ONLY: "deliveries only",
  PRODUCTIVITY: "productivity",
  TIME_TRACKING_ONLY: "time tracking only",
};

export const ROLES = {
  administrator: {
    id: 0,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: [
          "order_history",
          "billing_address",
          "delivery_addresses",
          "collaborate",
          "contacts",
          "settings",
        ],
      },
      { path: "/flashings", tabs: [] },
      { path: "/customers", tabs: [] },
      { path: "/dashboard", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
      {
        path: "/products",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      {
        path: "/product-kits",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      { path: "/inventory/stocktake", tabs: [] },
      { path: "/materials", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
          "settings",
        ],
      },
      { path: "/orders", tabs: [] },
      { path: "/sales_order", tabs: [] },
      { path: "/pdf_editor", tabs: [] },
      {
        path: "/settings",
        tabs: [
          "developer",
          "company",
          "billing",
          "integrations",
          "invoicing",
          "order_confirmations",
          "sales",
          "customers",
          "purchasing",
          "pdf",
          "pdf_document_templates",
          "select_pdf_templates",
          "quotes",
          "team",
          "time_tracking",
          // WS-7.1: Work Schedule is administrators only; other roles see it greyed out.
          "work_schedule",
          "order_importer",
        ],
      },
      { path: "/dashboard-beta", tabs: [] },
      { path: "/prices", tabs: [] },
      { path: "/pdf-customisation", tabs: [] },
    ],
    startPage: "/dashboard",
    description: "Access and make changes to all elements of Factory.",
  },
  "power user": {
    id: 1,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: [
          "order_history",
          "billing_address",
          "delivery_addresses",
          "collaborate",
          "contacts",
          "settings",
        ],
      },
      { path: "/flashings", tabs: [] },
      { path: "/dashboard", tabs: [] },
      { path: "/customers", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/timesheets", tabs: [] },
      { path: "/timesheets/individual", tabs: [] },
      {
        path: "/products",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      {
        path: "/product-kits",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      { path: "/inventory/stocktake", tabs: [] },
      { path: "/materials", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
          "settings",
        ],
      },
      { path: "/orders", tabs: [] },
      {
        path: "/settings",
        tabs: [
          "company",
          "integrations",
          "invoicing",
          "order_confirmations",
          "sales",
          "customers",
          "purchasing",
          "pdf",
          "quotes",
        ],
      },
      { path: "/dashboard-beta", tabs: [] },
      { path: "/prices", tabs: [] },
    ],
    startPage: "/dashboard",
    description: "Access and make changes to all elements of Factory, excluding user management.",
  },
  "standard user": {
    id: 2,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: ["order_history", "billing_address", "delivery_addresses", "collaborate", "contacts"],
      },
      { path: "/flashings", tabs: [] },
      { path: "/dashboard", tabs: [] },
      { path: "/customers", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/timesheets", tabs: [] },
      { path: "/timesheets/individual", tabs: [] },
      {
        path: "/products",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      {
        path: "/product-kits",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      { path: "/inventory/stocktake", tabs: [] },
      { path: "/materials", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
        ],
      },
      { path: "/orders", tabs: [] },
      { path: "/prices", tabs: [] },
      { path: "/dashboard-beta", tabs: [] },
    ],
    startPage: "/dashboard",
    description: "Create and manage sales orders, purchase orders and invoices.",
  },
  "standard user (No Invoicing)": {
    id: 3,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: ["order_history", "billing_address", "delivery_addresses", "collaborate", "contacts"],
      },
      { path: "/flashings", tabs: [] },
      { path: "/customers", tabs: [] },
      { path: "/dashboard", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/timesheets/individual", tabs: [] },
      {
        path: "/products",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      {
        path: "/product-kits",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      { path: "/materials", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
        ],
      },
      { path: "/orders", tabs: [] },
      { path: "/prices", tabs: [] },
      { path: "/dashboard-beta", tabs: [] },
    ],
    startPage: "/dashboard",
    description: "Identical to ‘Standard User’, excluding ability to generate or issue invoices.",
  },
  "standard user (No Pricing)": {
    id: 7,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: ["order_history", "billing_address", "delivery_addresses", "collaborate", "contacts"],
      },
      { path: "/customers", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/orders", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
        ],
      },
    ],
    startPage: "/orders",
    description:
      "Identical to ‘Standard User (No Invoicing)’, but with all pricing information hidden.",
  },
  "workflow only": {
    id: 4,
    access: [
      { path: "/profile", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
    ],
    startPage: "/workflow",
    description: "Access workflow tool only.",
  },

  "deliveries only": {
    id: 5,
    access: [
      { path: "/profile", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
    ],
    startPage: "/delivery_scheduling",
    description: "Access delivery scheduling tool only.",
  },
  productivity: {
    id: 6,
    access: [
      { path: "/profile", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
    ],
    startPage: "/workflow",
    description: "Access Workflow, Planner and Delivery Scheduling.",
  },
  "time tracking only": {
    id: 9,
    access: [
      { path: "/profile", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
    ],
    startPage: "/timesheets",
    description: "Access Time Tracking, Timesheets, and Active Tracking.",
  },
  // BETA ROLES //
  "[BETA] administrator": {
    id: 0,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: [
          "order_history",
          "billing_address",
          "delivery_addresses",
          "collaborate",
          "contacts",
          "settings",
        ],
      },
      { path: "/flashings", tabs: [] },
      { path: "/customers", tabs: [] },
      { path: "/dashboard", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
      {
        path: "/products",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      {
        path: "/product-kits",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      { path: "/inventory/stocktake", tabs: [] },
      { path: "/materials", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
          "settings",
        ],
      },
      { path: "/pdf_editor", tabs: [] },
      { path: "/orders", tabs: [] },
      {
        path: "/settings",
        tabs: [
          "developer",
          "company",
          "integrations",
          "invoicing",
          "order_confirmations",
          "sales",
          "customers",
          "purchasing",
          "pdf",
          "pdf_document_templates",
          "select_pdf_templates",
          "quotes",
          "team",
          "time_tracking",
          // WS-7.1: Work Schedule is administrators only; other roles see it greyed out.
          "work_schedule",
          "order_importer",
        ],
      },
      { path: "/prices", tabs: [] },
      { path: "/pdf-customisation", tabs: [] },
    ],
    startPage: "/dashboard",
    description: "Access and make changes to all elements of Factory.",
  },
  "[BETA] power user": {
    id: 1,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: [
          "order_history",
          "billing_address",
          "delivery_addresses",
          "collaborate",
          "contacts",
          "settings",
        ],
      },
      { path: "/flashings", tabs: [] },
      { path: "/customers", tabs: [] },
      { path: "/dashboard", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
      {
        path: "/products",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      {
        path: "/product-kits",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      { path: "/inventory/stocktake", tabs: [] },
      { path: "/materials", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
          "settings",
        ],
      },
      { path: "/orders", tabs: [] },
      {
        path: "/settings",
        tabs: [
          "company",
          "integrations",
          "invoicing",
          "order_confirmations",
          "sales",
          "customers",
          "purchasing",
          "pdf",
          "quotes",
        ],
      },
      { path: "/prices", tabs: [] },
    ],
    startPage: "/dashboard",
    description: "Access and make changes to all elements of Factory, excluding user management.",
  },
  "[BETA] standard user": {
    id: 2,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: ["order_history", "billing_address", "delivery_addresses", "collaborate", "contacts"],
      },
      { path: "/flashings", tabs: [] },
      { path: "/customers", tabs: [] },
      { path: "/dashboard", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
      {
        path: "/products",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      {
        path: "/product-kits",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      { path: "/inventory/stocktake", tabs: [] },
      { path: "/materials", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
        ],
      },
      { path: "/orders", tabs: [] },
      { path: "/prices", tabs: [] },
    ],
    startPage: "/dashboard",
    description: "Create and manage sales orders, purchase orders and invoices.",
  },
  "[BETA] standard user (No Invoicing)": {
    id: 3,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: ["order_history", "billing_address", "delivery_addresses", "collaborate", "contacts"],
      },
      { path: "/flashings", tabs: [] },
      { path: "/customers", tabs: [] },
      { path: "/dashboard", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/planner", tabs: [] },
      {
        path: "/products",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      {
        path: "/product-kits",
        tabs: ["product-details", "collaborate", "order-history"],
      },
      { path: "/inventory/stocktake", tabs: [] },
      { path: "/materials", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
        ],
      },
      { path: "/orders", tabs: [] },
      { path: "/prices", tabs: [] },
    ],
    startPage: "/dashboard",
    description: "Identical to ‘Standard User’, excluding ability to generate or issue invoices.",
  },
  "[BETA] standard user (No Pricing)": {
    id: 7,
    access: [
      { path: "/profile", tabs: [] },
      {
        path: "/customer",
        tabs: ["order_history", "billing_address", "delivery_addresses", "collaborate", "contacts"],
      },
      { path: "/customers", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/orders", tabs: [] },
      { path: "/timesheets/individual", tabs: [] },
      { path: "/purchases", tabs: [] },
      {
        path: "/suppliers",
        tabs: [
          "purchase-history",
          "supplier-details",
          "supplied-products",
          "collaborate",
          "contacts",
        ],
      },
    ],
    startPage: "/orders",
    description:
      "Identical to 'Standard User (No Invoicing)', but with all pricing information hidden.",
  },
  "[BETA] workflow only": {
    id: 4,
    access: [
      { path: "/profile", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
    ],
    startPage: "/workflow",
    description: "Access workflow tool only.",
  },
  "[BETA] deliveries only": {
    id: 5,
    access: [
      { path: "/profile", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
    ],
    startPage: "/delivery_scheduling",
    description: "Access delivery scheduling tool only.",
  },
  "[BETA] productivity": {
    id: 6,
    access: [
      { path: "/profile", tabs: [] },
      { path: "/workflow", tabs: [] },
      { path: "/planner", tabs: [] },
      { path: "/delivery_scheduling", tabs: [] },
      { path: "/timesheets", tabs: ["manager", "timeline"] },
      { path: "/timesheets/individual", tabs: [] },
    ],
    startPage: "/workflow",
    description: "Access Workflow, Planner and Delivery Scheduling.",
  },
};

// Roles blocked from inline-editing the Required Date on orders/quotes/POs.
// See FAC-4940 — these limited-access roles can view but not edit dates.
export const REQUIRED_DATE_BLOCKED_ROLE_IDS = [
  ROLES[ROLE_KEYS.WORKFLOW_ONLY].id,
  ROLES[ROLE_KEYS.DELIVERIES_ONLY].id,
  ROLES[ROLE_KEYS.PRODUCTIVITY].id,
  ROLES[ROLE_KEYS.TIME_TRACKING_ONLY].id,
];

export default ROLES;
